import StyledLink from '../StyledLink'
import {
  ADD,
  SYSTEM,
  TEST_MANAGEMENT_TOOLS
} from '../routes'
import type { Props } from '../types'

const LinkToAddTestManagementTool = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={`/${SYSTEM}/${TEST_MANAGEMENT_TOOLS}/${ADD}`}
  >
    {children}
  </StyledLink>

export default LinkToAddTestManagementTool
